import React from "react";
import { formatNumber } from "./charts/chartTheme";

function Money({ value }) {
  return <span className="whitespace-nowrap font-medium tabular-nums text-slate-900 dark:text-slate-50">{formatNumber(value, 2)}</span>;
}

/** Items and payment methods of one receipt (shown inside the expanded row of the receipts list). */
export default function ReceiptDetail({ data }) {
  const items = data.stavke || [];
  const payments = data.placanja || [];
  return (
    <div className="flex flex-col gap-3 text-sm">
      {items.length === 0 ? (
        <p className="text-slate-500 dark:text-slate-400">Račun nema stavki.</p>
      ) : (
        <ul className="flex flex-col divide-y divide-slate-200 dark:divide-slate-700">
          {items.map((it, i) => (
            <li key={i} className="flex items-baseline justify-between gap-3 py-1.5 first:pt-0">
              <span className="min-w-0 text-slate-800 dark:text-slate-100">
                {it.artikal || "Nepoznat artikal"}
                <span className="ml-2 text-xs tabular-nums text-slate-500 dark:text-slate-400">× {formatNumber(it.kolicina, it.kolicina % 1 ? 3 : 0)}</span>
              </span>
              <Money value={it.vrednost} />
            </li>
          ))}
        </ul>
      )}
      {payments.length > 0 && (
        <div className="flex flex-col gap-1 border-t border-slate-200 pt-2 text-xs dark:border-slate-700">
          <span className="font-medium text-slate-500 dark:text-slate-400">Plaćanje</span>
          {payments.map((p, i) => (
            <div key={i} className="flex items-baseline justify-between gap-3 text-sm">
              <span className="text-slate-700 dark:text-slate-200">{p.naziv || "Ostalo"}</span>
              <Money value={p.vrednost} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
